import React, { useEffect, useRef, useState } from 'react';
import { ModalButtonArea } from './';
import { icons } from '../assets';
import {
  // apiGetMembersList,
  // apiGetOrganization,
  apiGetPermissionForShare,
  apiShareModel,
  apiShareMultipleModelType,
  GetProductShareStatus,
  UpdateProductPublicShare,
  MakeProductPublicShare,
  getSharedFileToMemberList,
  getSharedFileToOrganizationList,
  removeUserFromSharedFile,
  apiGetPublicUUID,
  apiCreatePublicUUID,
  GetTextureShareStatus,
  apiGetPublicUUIDTexture,
  apiCreatePublicUUIDTexture,
  UpdateTexturePublicShare,
  MakeTexturePublicShare,
} from '../helpers/api';
// import closeIcon from '../assets/images/close-btn.png';
import { Button, Form, Modal, ModalTitle } from 'react-bootstrap';
import { CURRENT_USER } from '../constants/projectConstants';
import { getLocalStorage } from '../helpers/jsHelper';
const {
  ShareIcon,
  SearchIcon,
  CloseIcon,
  WarningIcon,
  RoundcloseIcon,
  ShareIconNew,
  ExclamationIcon,
} = icons;
import '../assets/scss/modules/_sharepopup.scss';
import CircularProgress from './CircularProgress';
import { COLLECTION_MODEL_TYPE__SHARE_TYPE__MAP, MODEL_TYPES } from '../constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import { searchSelector } from '../redux/slicers/search/searchSlicer';
import { GetOrgMembersList, GetSearchMembersList } from '../api/share/share';
import { ModalArea } from './ModalButtonArea';
import { ShareLinkInput } from './ShareLinkInput/ShareLinkInput';
import {
  ADMIN_MY_PRODUCTS_3DMODAL,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2,
  ADMIN_MY_PRODUCTS_TEXTURE,
  ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2,
  COLLECTIONS_ROUTE,
  PRODUCT_WEB_EXPERIENCE_PUBLIC,
} from '../constants/routePathConstants';
import Switch from '../components/admin/switch';
import Loader from './Loader';
import { errorToast, successToast, warningToast } from '../helpers/toastHelper';
import { USER_PROFILE_PLACEHOLDER } from '../config/constant/assetConstant';
import { useLocation } from 'react-router-dom';
import { MESSAGE_DESCRIPTION_LENGTH } from '../constants/validationConstants';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { Mixpanel, MxEvent } from './Mixpanel';
import { useCopyToClipboard } from 'react-use';
import { useUserContext } from '../contexts/UserContext';
import { ConfiguratorShareBody } from '../components/Configurator/Share/ShareDialog';
import { selectCurrentConfigurator } from '../redux/slicers/configurator/configurator.slicer';

// this is BAAAAD -> refactor it when have some time -> we already have all this numbers/strings in variables ->>>  DRY  -> Don't Repeat Yourself!!!!!
const MODEL_TYPES_FOR_SHARE_COLLECTION_ITEM = {
  collection: {
    key: 'id',
    getId: (data) => data.data.id,
    type: {
      1: 'product',
      2: 'product',
      3: 'texture',
      4: 'texture',
      5: 'room',
      6: 'room',
      7: 'projectrender',
      8: 'projectrender',
      9: 'project',
      10: 'material', // not able to share
    },
  },
  sharedFiles: {
    key: 'data.id',
    getId: (data) => data.data.id,
    type: {
      1: 'product',
      2: 'texture',
      3: 'room',
      4: 'project',
      5: 'collection',
      6: 'projectrender',
    },
  },
};

export default function SharePopup(props) {
  const location = useLocation();
  // currently, we are not sharing collection with other organisation
  const limitingOptionToShare = location?.pathname.includes(COLLECTIONS_ROUTE);
  // console.log("limitingOptionToShare", limitingOptionToShare)

  const modelType = props?.modelType || props?.sharedFile?.model_type;
  let title = limitingOptionToShare ? 'Share files with members' : 'Share files with';
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (props.setShareModal) {
      props.setShareModal(showModal);
    }
  }, [showModal]);

  return (
    <ModalButtonArea
      button={props.button}
      bigButton={props.bigButton}
      bigBtnClass={props?.bigBtnClass}
      hideButtonText={props.hideButtonText}
      miniButton={props.miniButton}
      footerButton={props.footerButton}
      variant={props.disabled ? 'outline-secondary' : 'secondary'}
      buttonIcon={props.icon || ShareIcon}
      buttonTitle="Share"
      disabled={props.disabled || false}
      title={props.title || title}
      // subtitle={subtitle}
      size="lg"
      body={
        <Body
          selectedModels={
            props?.selectedList === undefined || typeof props?.selectedList === 'boolean'
              ? [{ id: props?.shareId || props.id }]
              : props?.selectedList
          }
          modelType={modelType}
          setShowModal={setShowModal}
          onSuccess={props.onSuccess}
          limitingOptionToShare={limitingOptionToShare}
        />
      }
      iconSrc={props.iconSrc}
      showModal={showModal}
      setShowModal={setShowModal}
      buttonLabel={props.buttonLabel}
    />
  );
}

export const SharePopupONLY = ({
  show,
  toggleModal,
  className,
  title,
  subtitle,
  modelType,
  onSuccess,
  centered,
  promptButton,
  includeCancelButton,
  animation,
  selectedModels, // remove this
  shareData,
  onPublicToggle,
  publicToggleLoading,
}) => {
  const location = useLocation();
  // currently, we are not sharing collection with other organisation
  const limitingOptionToShare = location?.pathname.includes(COLLECTIONS_ROUTE);
  // console.log("limitingOptionToShare", limitingOptionToShare)

  return (
    <ModalArea
      showModal={show}
      setShowModal={toggleModal}
      className={className}
      title={limitingOptionToShare ? 'Share files with members' : title}
      subtitle={subtitle}
      animation={animation}
      includeCancelButton={includeCancelButton}
      promptButton={promptButton}
      size="lg"
      centered={centered}
      body={
        <Body
          selectedModels={selectedModels} // remove this
          shareData={shareData}
          modelType={modelType}
          setShowModal={toggleModal}
          onSuccess={onSuccess}
          onPublicToggle={onPublicToggle}
          publicToggleLoading={publicToggleLoading}
          limitingOptionToShare={limitingOptionToShare}
        />
      }
    />
  );
};

export const handleCopyURL = ({
  productId,
  productUnicode,
  isV2,
  isTexture,
  isEmbed = false,
  copy,
  disableCopy = false,
  showMessage = true,
  isFrameCode = false,
  trackingEnable = false
}) => {
  if (productId && productUnicode) {
    const route = isV2
      ? isTexture
        ? ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2
        : ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2
      : ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC;
    const URL = `${window.location?.origin}${route?.replace(':id', '')}${productUnicode}${trackingEnable ? '?t=1' : ''}`; // ?product_org=${currentUser?.organization}`;
    const iframeCode = `<iframe style="border: none;" src="${URL}${trackingEnable ? '&' : '?'}toolbar=0" title="${productId}" width="100%" height="768px" allowfullscreen></iframe>`;
    if (!disableCopy) copy(isEmbed ? iframeCode : URL);
    if (showMessage) successToast(`${isEmbed ? 'Embed' : ''} Link Copied`);
    if(isFrameCode){
      return iframeCode
    }
    return URL;
  }
  return null
};

export const Body = ({
  selectedModels, // remove this
  shareData,
  modelType,
  setShowModal,
  onSuccess,
  onPublicToggle,
  publicToggleLoading,
  limitingOptionToShare,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { currentUser } = useUserContext();
  const productId = window?.location?.pathname.split('/')?.reverse()?.[0] || null;

  const { openInfoDialog } = useInfoDialogaActions();

  const userInfo = getLocalStorage(CURRENT_USER, true);
  const searchRef = useRef(null);
  const { searchUserResult, searchOrgResult } = useSelector(searchSelector);
  const hasConfiguratorData = useSelector(selectCurrentConfigurator);
  const isExperienceModel = modelType === MODEL_TYPES.WEBEXPERIENCE;
  const isRenderPreviewModal = modelType
    ? modelType.toString() === MODEL_TYPES.PROJECTRENDER.toString()
    : false;

  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState('users');
  const [searchText, setSearchText] = useState('');
  const [messageText, setMessageText] = useState('');
  const [selectedUser, setSelectedUser] = useState([]);
  const [errors, setErrors] = useState([]);
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [sharedModelDetails, setSharedModelDetails] = useState();
  const [reFetch, setReFetch] = useState(false);
  const [publicShare, setPublicShare] = useState(false);
  const [shareAPIData, setShareAPIData] = useState(null);
  const [showSharingOption, setShowSharingOption] = useState(false);
  const [productUnicode, setProductUnicode] = useState(null);
  const [loadingShare, setLoadingShare] = useState(false);
  const isTexture = Boolean(selectedModels?.find((val) => val?.is_texture));
  const isV2 = Boolean(selectedModels?.find((val) => val?.is_v2));
  const [state, copy] = useCopyToClipboard();

  useEffect(() => {
    // check the popup open from product page
    if (
      location?.pathname?.match(`${ADMIN_MY_PRODUCTS_3DMODAL}/`)?.length ||
      location?.pathname?.match(`${ADMIN_MY_PRODUCTS_TEXTURE}/`)?.length
    ) {
      if (window.$shareFlag) {
        setPublicShare(true);
        setShareAPIData(window.$shareItem);
        setProductUnicode(window.$shareItem?.unique_code); //.product_details?.unicode)
      }
      setShowSharingOption(true);
    } else {
      setShowSharingOption(false);
    }
  }, [location?.pathname]);

  useEffect(async () => {
    // get the current the sharing for this current product
    if (showSharingOption && productId) {
      setLoadingShare(true);
      const getFunc = isTexture ? GetTextureShareStatus : GetProductShareStatus;
      const res = await getFunc(productId);
      setLoadingShare(false);
      if (res?.results?.length) {
        setShareAPIData(res?.results[0] || null);
        window.$shareItem = res?.results?.[0];
        window.$shareFlag = res?.results?.[0]?.is_public;
        if (res?.results[0]?.is_public) {
          const getPublicUUID = isTexture ? apiGetPublicUUIDTexture : apiGetPublicUUID;
          const response = await getPublicUUID(
            `?${isTexture ? 'texture' : 'product'}=${productId}`
          );
          if (response?.results?.length) {
            setProductUnicode(response.results[0]?.unique_code);
            window.$shareItem.unique_code = response?.data?.unique_code;
            // setPublicUUID(response.results[0]?.unique_code);
          } else {
            const formData = new FormData();
            formData.append(isTexture ? 'texture' : 'product', productId);
            const createFunc = isTexture ? apiCreatePublicUUIDTexture : apiCreatePublicUUID;
            const response = await createFunc(formData);
            if (response?.status) {
              setProductUnicode(response?.data?.unique_code);
              window.$shareItem.unique_code = response?.data?.unique_code;
            }
          }
          // setProductUnicode(res?.results[0]?.product_details?.unicode);
          setPublicShare(true);
        } else {
          setPublicShare(false);
        }
      }
      else {
        window.$shareItem = null;
        window.$shareFlag = false;
      }
    }
  }, [showSharingOption, isTexture]);

  const commonDialogProps = {
    cancelButtonText: 'Cancel',
    cancelBtnColor: 'light',
    okBtnColor: 'warning',
  };

  const handleSelect = (value) => {
    setSearchText('');
    setIsSearchFocused(false);
    if (selectedUser.filter((item) => item?.id === value?.id).length) {
      if (value.warning) {
        setErrors(errors.filter((item) => item?.id !== value?.id));
      }
      setSelectedUser(selectedUser.filter((item) => item?.id !== value?.id));
    } else {
      if (value.warning) {
        setErrors([...errors, value]);
      }
      setSelectedUser([...selectedUser, value]);
    }
  };

  const onEnterPress = ({ key }) => {
    if (key === 'Enter' && searchText) {
      if (selectedTab === 'users') {
        const selectUser = searchUserResult?.results.filter(
          (user) => !selectedUser.some((item) => item?.id === user?.id)
        )?.[0];
        handleSelect(
          selectUser
            ? {
                id: selectUser?.id,
                member_profile: selectUser?.member_profile,
                member_name: selectUser?.member_name,
                warning: false,
                is_my_org: selectUser?.is_my_org,
                is_org: false,
              }
            : {
                id: Math.random(),
                member_name: searchText,
                member_profile: 'put here warning icon',
                warning: true,
                is_org: false,
              }
        );
      } else {
        const selectOrg = searchOrgResult?.results.filter(
          (user) => !selectedUser.some((item) => item?.id === user?.id)
        )?.[0];
        handleSelect(
          selectOrg
            ? {
                id: selectOrg?.id,
                member_profile: selectOrg?.organization_owner_profile,
                member_name: selectOrg?.name,
                warning: false,
                is_my_org: selectOrg?.is_my_org,
                is_org: true,
              }
            : {
                id: Math.random(),
                member_name: searchText,
                member_profile: 'put here warning icon',
                warning: true,
                is_org: true,
              }
        );
      }
      setSearchText('');
    }
  };

  const requestPermission = async (permission_code) => {
    if (!permission_code) {
      warningToast(`You can\'t share ${selectedModels.length > 1 ? 'these items.' : 'this item.'}`);
      return;
    }
    const formData = new FormData();
    formData.append('permission_type', permission_code);

    await apiGetPermissionForShare(formData);
    setShowModal(false);
  };

  const handleShareMixpanel = (eventType, sharedToType, sharedToDetails, sharedItemDetails) => {
    let mxEvent = null;
    switch (eventType) {
      case '1':
        mxEvent = MxEvent.SHARED_PROP;
        break;
      case '2':
        mxEvent = MxEvent.SHARED_TEXTURE;
        break;
      case '3':
        mxEvent = MxEvent.SHARED_TEMPLATE;
        break;
      case '4':
        mxEvent = MxEvent.SHARED_PROJECT;
        break;
      case '5':
        mxEvent = MxEvent.SHARED_COLLECTIONS;
        break;
      case '6':
        mxEvent = MxEvent.SHARED_IMAGE;
        break;
      default:
        console.log('mx: ', 'New share type: ', eventType);
        break;
    }

    const sharedItemNameAndId = {
      id: sharedItemDetails?.id,
      name: sharedItemDetails?.name,
    };

    const sharedToNameAndId = sharedToDetails.map((a) => {
      return {
        id: a?.id,
        name: a?.member_name,
      };
    });
    // 1 means props items
    if (eventType === '1' && sharedItemDetails?.is_prop_group) {
      Mixpanel.track(true, MxEvent.PG_SHARE, {
        pg_share_files_with: sharedToType,
        ...(sharedToType !== 'Team member' && { pg_org_name_list: sharedToNameAndId }),
        ...(sharedToType === 'Team member' && { pg_member_name_list: sharedToNameAndId }),
        pg_name: sharedItemNameAndId.name,
      });
    }
    Mixpanel.track(true, mxEvent, {
      'Shared to type': sharedToType,
      'Shared to details': sharedToNameAndId,
      'Shared item details': sharedItemNameAndId,
    });
  };

  const handleShare = async () => {
    const model_ids = selectedModels.map((item) => item?.id).join(',');

    if (errors.length || !selectedUser?.length || !model_ids || !modelType) {
      if (errors.length) {
        errorToast('Please select valid user or organization');
      } else if (!selectedUser?.length) {
        errorToast('Please select atleast one user or organization');
      } else if (!model_ids) {
        errorToast('Please select atleast one file');
      } else if (!modelType) {
        errorToast('Please provide model type');
      }
      return;
    }

    const onShareClick = async () => {
      const formData = new FormData();
      //model type 0 for mix files
      if (modelType === 'collection' || modelType === 'sharedFiles') {
        const shareModels = {};
        selectedModels.forEach((item) => {
          const calculatedItemId = MODEL_TYPES_FOR_SHARE_COLLECTION_ITEM[modelType]?.getId?.(item);
          const key = MODEL_TYPES_FOR_SHARE_COLLECTION_ITEM?.[modelType]?.type?.[item?.model_type];

          if (key) {
            shareModels[key] = shareModels[key]
              ? `${shareModels[key]},${calculatedItemId}`
              : `${calculatedItemId}`;
          }
        });
        Object.keys(shareModels).forEach((key) => {
          formData.append(key, shareModels?.[key]);
        });
      } else {
        formData.append('model_type', modelType);
        formData.append('model_id', model_ids);
      }
      if (selectedUser?.filter((item) => item?.is_org === false)?.map((item) => item?.id).length) {
        handleShareMixpanel(modelType?.toString(), 'Team member', selectedUser, modelData);
        formData.append(
          'shared_to',
          selectedUser
            ?.filter((item) => item?.is_org === false)
            ?.map((item) => item?.id)
            .join(',')
        );
      }
      if (selectedUser?.filter((item) => item?.is_org === true)?.map((item) => item?.id).length) {
        handleShareMixpanel(modelType?.toString(), 'Other organization', selectedUser, modelData);
        formData.append(
          'shared_to_org',
          selectedUser
            ?.filter((item) => item?.is_org === true)
            ?.map((item) => item?.id)
            .join(',')
        );
      }
      formData.append('message', messageText);

      if (modelType === 'collection' || modelType === 'sharedFiles') {
        await apiShareMultipleModelType(formData, (response) => {
          if (response?.status === true) {
            setShowModal(false);
          } else {
            if (response?.message?.permission_code) {
              openInfoDialog({
                ...commonDialogProps,
                title: response?.message?.message || response?.message,
                buttonText: 'Request',
                onButtonClick: () => requestPermission(response?.message?.permission_code),
              });
            }
          }
        });
      } else {
        await apiShareModel(formData, (response) => {
          if (response?.status === true) {
            setShowModal(false);
          } else {
            if (response?.message?.permission_code) {
              openInfoDialog({
                ...commonDialogProps,
                title: response?.message?.message || response?.message,
                buttonText: 'Request',
                onButtonClick: () => requestPermission(response?.message?.permission_code),
              });
            }
          }
        });
      }
    };

    if (selectedUser.findIndex((item) => item?.is_my_org === false) !== -1) {
      if (selectedModels?.findIndex((item) => item?.owner_organization !== null) !== -1) {
        // TODO: This is for temporary basis, we need to rework on sharing once it's new ui and functionality completed
        if (isRenderPreviewModal) {
          onShareClick();
          return;
        }

        openInfoDialog({
          ...commonDialogProps,
          title: 'This file contains exclusive data like  models or rooms',
          description: 'Are you sure you want to share the files?',
          buttonText: 'Share',
          onButtonClick: () => onShareClick(),
        });
      } else {
        openInfoDialog({
          ...commonDialogProps,
          title: 'You are about to share files with people outside of your organization',
          description: 'Are you sure you want to share the files?',
          buttonText: 'Share',
          onButtonClick: () => onShareClick(),
        });
      }
    } else {
      onShareClick();
    }
  };

  const shareButton = (
    <button
      disabled={messageText.length > MESSAGE_DESCRIPTION_LENGTH}
      className="btn"
      onClick={handleShare}>
      Share
    </button>
  );

  const handleCloseSearchPanel = () => {
    setIsSearchFocused(false);
  };

  const handleUnshareModel = async (user) => {
    let _modelType = modelType;
    if (modelType === 'sharedFiles') {
      if (modelType === 'collection') {
        const collectionModelType = modelData.model_type;
        _modelType = COLLECTION_MODEL_TYPE__SHARE_TYPE__MAP[collectionModelType];
      } else {
        _modelType = modelData.model_type;
      }
    }
    const formData = new FormData();
    formData.append('model_type', _modelType || modelType);
    formData.append('model_id', selectedModels?.[0]?.id);
    if (user?.organization_details) {
      formData.append('org_id', user?.organization_details?.id);
    } else {
      formData.append('member_id', user?.id);
    }

    await removeUserFromSharedFile(formData);
    setReFetch(true);
    // setSharedModelDetails({
    //   ...sharedModelDetails,
    //   results: sharedModelDetails?.results?.filter((item) => item?.id !== user?.id),
    // });
  };

  const isConfiguratorPublic = () => selectedTab === 'public';

  useEffect(async () => {
    setLoading(true);

    if (selectedTab === 'users') {
      dispatch(GetSearchMembersList(searchText));
      setLoading(false);
    } else {
      if (searchText) {
        dispatch(GetOrgMembersList(searchText));
      }
      setLoading(false);
    }
  }, [selectedTab]);

  useEffect(() => {
    setLoading(true);
    searchText && setIsSearchFocused(true);
    if (selectedTab === 'users') {
      dispatch(GetSearchMembersList(searchText));
      setLoading(false);
    } else {
      searchText && dispatch(GetOrgMembersList(searchText));
      setLoading(false);
    }
  }, [searchText]);

  //   useEffect(() => {
  //     if (!isSearchFocused) return;

  //     document.getElementById("pop-up-body")?.addEventListener("click", handleCloseSearchPanel);
  //     console.log("document.getElementById", document.getElementsByClassName("modal-content")[0])

  //     return () => {
  //       document.getElementById("pop-up-body")?.[0]?.removeEventListener("click", handleCloseSearchPanel);
  //     }
  //   }, [isSearchFocused])

  const modelData = selectedModels?.[0];
  useEffect(async () => {
    if (reFetch === 'stop') return;
    if (selectedModels.length === 1) {
      if (!modelData) return;

      let _modelType = modelType;
      let _id = modelData.id;

      if (modelType === 'collection' || modelType === 'sharedFiles') {
        _id = MODEL_TYPES_FOR_SHARE_COLLECTION_ITEM[modelType].getId(modelData);
        // _modelType = MODEL_TYPES_FOR_SHARE_COLLECTION_ITEM[modelType].type[numberModelType];
        if (modelType === 'collection') {
          const collectionModelType = modelData.model_type;
          _modelType = COLLECTION_MODEL_TYPE__SHARE_TYPE__MAP[collectionModelType];
        } else {
          _modelType = modelData.model_type;
        }
      }

      try {
        !reFetch && setLoading(true);
        const members = await getSharedFileToMemberList(_modelType, _id);
        const organizations = await getSharedFileToOrganizationList(_modelType, _id);

        // console.log('sharing list: ', members?.results, organizations?.results);

        const mResult = members?.results.map((a) => {
          const r = Object.assign({}, a);
          delete r?.organization_details;

          return r;
        });

        const result = {
          owner: members?.owner || organizations?.owner, // taking owner details from anyone as we have same owners here as this is only for single selected card not for multiple
          results: [...mResult, ...organizations?.results],
        };

        // console.log('sharing list result: ', result);

        setSharedModelDetails(result);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
        if (reFetch) {
          setReFetch('stop');
        }
      }
    }
  }, [modelType, modelData?.id, reFetch]);

  // update product sharing status like public or non-public
  const handleToggleChange = async () => {
    if (productId && !loadingShare) {
      const payload = {
        [isTexture ? 'texture' : 'product']: productId,
        is_publish: true,
        is_public: !publicShare,
      };
      let res = null;
      if (shareAPIData && Object.keys(shareAPIData)?.length) {
        const updateFunc = isTexture ? UpdateTexturePublicShare : UpdateProductPublicShare;
        res = await updateFunc(payload);
      } else {
        const makeFunc = isTexture ? MakeTexturePublicShare : MakeProductPublicShare;
        res = await makeFunc(payload);
      }
      if (res?.status && res?.data) {
        window.$shareItem = res?.data;
        window.$shareFlag = res?.data?.is_public;
        setShareAPIData(res?.data);
        const getFunc = isTexture ? apiGetPublicUUIDTexture : apiGetPublicUUID;
        const response = await getFunc(`?${isTexture ? 'texture' : 'product'}=${productId}`);
        if (response?.results?.length) {
          setProductUnicode(response.results[0]?.unique_code);
          window.$shareItem.unique_code = response?.data?.unique_code;
          // setPublicUUID(response.results[0]?.unique_code);
        } else {
          const formData = new FormData();
          formData.append(isTexture ? 'texture' : 'product', productId);
          const createFunc = isTexture ? apiCreatePublicUUIDTexture : apiCreatePublicUUID;
          const response = await createFunc(formData);
          if (response?.status) {
            setProductUnicode(response?.data?.unique_code);
            window.$shareItem.unique_code = response?.data?.unique_code;
          }
        }

        // setProductUnicode(res?.data?.product_details?.unicode);
        setPublicShare(!publicShare);
      } else {
        window.$shareItem = null;
        window.$shareFlag = false;
        setProductUnicode(null);
      }
    }
  };

  return (
    <div className="shared-model-inner-part" onClick={() => setIsSearchFocused(false)}>
      {!limitingOptionToShare && (
        <div className="d-flex justify-content-center share-tab-btn">
          <button
            className={`btn ${selectedTab === 'users' ? 'btn-active' : 'btn-inactive'}`}
            onClick={() => setSelectedTab('users')}>
            Members
          </button>
          <button
            className={`btn ${selectedTab === 'organizations' ? 'btn-active' : 'btn-inactive'}`}
            onClick={() => setSelectedTab('organizations')}
            style={hasConfiguratorData?.is_render_created ? { borderRadius: '0' } : {}}>
            Organizations
          </button>
          {hasConfiguratorData?.is_render_created ? (
            <button
              className={`btn ${selectedTab === 'public' ? 'btn-active' : 'btn-inactive'}`}
              onClick={() => setSelectedTab('public')}>
              Public
            </button>
          ) : null}
        </div>
      )}

      <div className="d-flex flex-column position-relative">
        {!isConfiguratorPublic() ? (
          <div
            className={`main-search-part position-relative ${
              searchText || selectedUser?.length ? 'active-searchbar' : ''
            }`}
            onClick={(e) => {
              e.stopPropagation();
              setIsSearchFocused(true);
              searchRef?.current?.focus();
            }}>
            <div className="d-flex flex-wrap w-100 pt-2 pb-2 gap-2">
              {!selectedUser?.length && !isSearchFocused && !searchText ? (
                <div className="search-icon">
                  <SearchIcon />
                </div>
              ) : (
                ''
              )}
              {selectedUser?.map((item) => (
                <span className={`search-selected-item ${item?.warning ? 'text-danger' : ''}`}>
                  {item?.warning ? (
                    <WarningIcon />
                  ) : (
                    <img
                      className="search-user-icon"
                      src={item?.member_profile || USER_PROFILE_PLACEHOLDER}
                    />
                  )}
                  <span className="search-selected-text">{item?.member_name}</span>
                  <span
                    onClick={() => handleSelect(item)}
                    className="round-close-btn"
                    style={{ cursor: 'pointer' }}>
                    <RoundcloseIcon />
                  </span>
                </span>
              ))}
              <input
                ref={searchRef}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder={
                  selectedUser?.length || isSearchFocused ? '' : 'Email, comma separated'
                }
                onKeyDown={onEnterPress}
              />
            </div>
            {searchText ? (
              <span
                className="round-close-btn"
                style={{ cursor: 'pointer' }}
                onClick={() => setSearchText('')}>
                <RoundcloseIcon />
              </span>
            ) : (
              ''
            )}
          </div>
        ) : null}
        <div className="filteredDataList">
          {selectedTab === 'users' ? (
            <>
              {isSearchFocused &&
              searchUserResult?.results.filter(
                (user) => !selectedUser.some((item) => item?.id === user?.id)
              )?.length ? (
                <div className="users-list-box popup-userlist-box mb-3">
                  {loading === true ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 280,
                      }}>
                      <CircularProgress />
                    </div>
                  ) : (
                    searchUserResult?.results
                      .filter((user) => !selectedUser.some((item) => item?.id === user?.id))
                      .map((user) => (
                        <div
                          key={user?.id}
                          className="d-flex align-items-center justify-content-between users-inner-list"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect({
                              id: user?.id,
                              member_profile: user?.member_profile,
                              member_name: user?.member_name,
                              warning: false,
                              is_my_org: user?.is_my_org,
                              is_org: false,
                            });
                          }}>
                          <div className="d-flex align-items-center">
                            <img
                              className="users-inner-image"
                              src={user?.member_profile || USER_PROFILE_PLACEHOLDER}
                            />
                            <div className="users-inner-text">
                              <div className="user-inner-name">{user?.member_name}</div>
                              <div className="user-inner-email">{user?.member_email}</div>
                            </div>
                          </div>
                          {selectedUser.filter((item) => item?.id === user?.id).length ? (
                            <span
                              onClick={() =>
                                handleSelect({
                                  id: user?.id,
                                  member_profile: user?.member_profile,
                                  member_name: user?.member_name,
                                  warning: false,
                                  is_my_org: user?.is_my_org,
                                  is_org: false,
                                })
                              }
                              className="round-close-btn">
                              <RoundcloseIcon />
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      ))
                  )}
                  {/* {!loading && searchUserResult?.results?.length === 0 ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 150,
                      }}>
                      No User Found
                    </div>
                  ) : (
                    ''
                  )} */}
                </div>
              ) : (
                ''
              )}
            </>
          ) : selectedTab === 'organizations' ? (
            <>
              {searchOrgResult?.results.filter(
                (user) => !selectedUser.some((item) => item?.id === user?.id)
              ).length && searchText ? (
                <div className="users-list-box popup-userlist-box position-relative mb-3">
                  {loading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 280,
                      }}>
                      <CircularProgress />
                    </div>
                  ) : (
                    searchOrgResult?.results
                      .filter((user) => !selectedUser.some((item) => item?.id === user?.id))
                      .map((org) => (
                        <div
                          key={org?.id}
                          className="d-flex align-items-center justify-content-between users-inner-list"
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect({
                              id: org?.id,
                              member_profile: org?.organization_owner_profile,
                              member_name: org?.name,
                              warning: false,
                              is_my_org: userInfo?.organization_detail?.id === org?.id,
                              is_org: true,
                            });
                          }}>
                          <div className="d-flex align-items-center">
                            <img
                              className="users-inner-image"
                              src={org?.organization_owner_profile || USER_PROFILE_PLACEHOLDER}
                            />
                            <div className="users-inner-text">
                              <div className="user-inner-name">{org?.organization_owner_email}</div>
                              <div className="user-inner-email">organization: {org?.name}</div>
                            </div>
                          </div>
                          {selectedUser.filter((item) => item?.id === org?.id).length ? (
                            <span
                              onClick={() =>
                                handleSelect({
                                  id: org?.id,
                                  member_profile: org?.thumbnail,
                                  member_name: org?.name,
                                  warning: false,
                                  is_my_org: userInfo?.organization_detail?.id === org?.id,
                                  is_org: true,
                                })
                              }
                              className="text-danger">
                              {/* className="round-close-btn"> */}
                              <RoundcloseIcon />
                            </span>
                          ) : (
                            ''
                          )}
                        </div>
                      ))
                  )}
                  {/* {!loading && searchOrgResult?.results?.length === 0 ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: 150,
                        }}>
                        No Organization Found
                      </div>
                    ) : (
                      ''
                    )} */}
                </div>
              ) : null}
            </>
          ) : selectedTab === 'public' ? (
            <div className="my-3" style={{ boxShadow: '3px 3px 5px 0px #00000008' }}>
              <ConfiguratorShareBody data={hasConfiguratorData} />
            </div>
          ) : null}
        </div>

        {!isConfiguratorPublic() ? (
          <>
            <div>
              {!isSearchFocused &&
              !selectedUser.length &&
              (sharedModelDetails?.owner?.member_email || sharedModelDetails?.results?.length) ? (
                <>
                  {sharedModelDetails?.results?.length !== 0 && <h6>This file is shared with</h6>}
                  <div className="users-list-box mb-3">
                    {loading && !searchText ? (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          height: 200,
                        }}>
                        <CircularProgress />
                      </div>
                    ) : (
                      <>
                        {sharedModelDetails?.owner?.member_email ? (
                          <div className="d-flex align-items-center justify-content-between users-inner-list align-items-center">
                            <div className="d-flex align-items-center">
                              <img
                                className="users-inner-image"
                                src={
                                  sharedModelDetails?.owner?.member_profile ||
                                  USER_PROFILE_PLACEHOLDER
                                }
                              />
                              <div className="users-inner-text">
                                <div className="user-inner-name">
                                  {sharedModelDetails?.owner?.member_name}
                                </div>
                                <div className="user-inner-email">
                                  {sharedModelDetails?.owner?.member_email}
                                </div>
                              </div>
                            </div>
                            <span>Owner</span>
                          </div>
                        ) : (
                          ''
                        )}
                        {sharedModelDetails?.results.map((user, index) => (
                          <div className="d-flex align-items-center justify-content-between users-inner-list align-items-center">
                            <div className="d-flex align-items-center">
                              <img
                                className="users-inner-image"
                                src={
                                  user?.organization_details?.thumbnail ||
                                  user?.member_profile ||
                                  USER_PROFILE_PLACEHOLDER
                                }
                              />
                              <div className="users-inner-text">
                                <div className="user-inner-name">
                                  {user?.organization_details?.name || user?.member_name}
                                </div>
                                {!user?.organization_details && (
                                  <div className="user-inner-email">{user?.member_email}</div>
                                )}
                              </div>
                            </div>
                            <span className="remove-btn" onClick={() => handleUnshareModel(user)}>
                              Remove Member
                            </span>
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                </>
              ) : null}
              {!isExperienceModel && !isSearchFocused && selectedUser.length ? (
                <div style={{ position: 'relative' }} className="mb-3">
                  {messageText.length > MESSAGE_DESCRIPTION_LENGTH && (
                    <label className="user-list-textarea-label text-danger">
                      <ExclamationIcon />
                      <span>{`Text limit must be less than ${MESSAGE_DESCRIPTION_LENGTH} characters.`}</span>
                    </label>
                  )}
                  <textarea
                    value={messageText}
                    onChange={(e) => setMessageText(e.target.value)}
                    className={`user-list-text-area w-100 ${
                      messageText.length > MESSAGE_DESCRIPTION_LENGTH ? 'input-error' : ''
                    }`}
                    placeholder="Add Message"
                  />
                </div>
              ) : (
                ''
              )}
            </div>

            <div className="fotter-part-model">
              {errors?.length ? (
                <div className="warning-text-part">
                  <WarningIcon width={27} height={27} />
                  <span className="text-danger">
                    {console.log(
                      'errors?.[errors?.length - 1]?.is_org',
                      errors?.[errors?.length - 1]
                    )}
                    {errors?.[errors?.length - 1]?.is_org
                      ? 'No Organization Found'
                      : 'No Member Found'}
                  </span>
                </div>
              ) : (
                ''
              )}

              {!isExperienceModel && !isSearchFocused && selectedUser.length ? shareButton : ''}

              {isExperienceModel && (
                <div className="w-100">
                  <hr className="mt-4" style={{ backgroundColor: 'var(--neutral40-color)' }} />
                  <div className="d-flex gap-3 justify-content-between w-100 align-items-end">
                    <ShareLinkSection
                      item={selectedModels?.[0]}
                      onPublicToggle={onPublicToggle}
                      publicToggleLoading={publicToggleLoading}
                    />
                    {shareButton}
                  </div>
                </div>
              )}
            </div>
          </>
        ) : null}
      </div>
      {/* if the user have the permission then show the sharing open      */}
      {showSharingOption && !isConfiguratorPublic() && (
        <div className="share-section">
          <span className="me-3">Enable Link Sharing</span>
          <Switch checked={publicShare} onToggle={handleToggleChange} />
          {publicShare && (
            <div className="share-box my-3">
              <p className="mb-0">
                <b>Anyone</b> on the internet with this link can view
              </p>
              <div>
                <span
                  className="copy-link me-3"
                  onClick={() =>
                    handleCopyURL({
                      productId,
                      productUnicode,
                      isV2,
                      isTexture,
                      isEmbed: true,
                      copy,
                    })
                  }>
                  Copy embed link
                </span>
                <span
                  className="copy-link"
                  onClick={() =>
                    handleCopyURL({ productId, productUnicode, isV2, isTexture, copy })
                  }>
                  Copy link
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

// const WarningModal = ({
//   showModal,
//   animation = true,
//   handleClose,
//   title,
//   subtitle,
//   btnTitle = "Share",
//   btnClick,
// }) => {
//   return (
//     <Modal
//       show={showModal}
//       animation={animation || false}
//       onHide={handleClose}
//       centered
//       dialogClassName={"new-item-modal"}
//     >
//       <Modal.Header className="commonPopupHeader justify-content-end pb-0">
//         <Button onClick={handleClose} className="modalCloseButton">
//           <CloseIcon />
//         </Button>
//       </Modal.Header>
//       {title && (
//         <ModalTitle className="text-center">
//           <h2 className="appH2">{title}</h2>
//         </ModalTitle>
//       )}
//       {subtitle && <h3 className="text-center appH3">{subtitle}</h3>}
//       <Modal.Body>
//         <div className="d-flex justify-content-around">
//           <button className="btn btn-light btn" onClick={handleClose}>
//             Cancel
//           </button>
//           <button onClick={btnClick} className="btn btn-warning">
//             {btnTitle}
//           </button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

export const ShareLinkSection = ({ item, onPublicToggle, publicToggleLoading }) => {
  if (!item) return null;

  const link = window.location.origin + PRODUCT_WEB_EXPERIENCE_PUBLIC.replace(':id', item.id);

  return (
    <div className="w-100 align-self-center">
      <Form.Group className="d-flex align-items-center">
        <Form.Label className="me-3 mb-0">Public Sharing</Form.Label>
        {publicToggleLoading ? (
          <Loader
            loading
            position="relative"
            size={25}
            thickness={2}
            style={{ width: 50, height: 25 }}
          />
        ) : (
          <Switch checked={item.is_public} onToggle={(e) => onPublicToggle(e.target.checked)} />
        )}
      </Form.Group>

      {item.is_public && <ShareLinkInput link={link} className="mt-4" />}
    </div>
  );
};

export const ShareAndCopyLinkSection = ({
  publicShare,
  unicode,
  productId,
  isTexture,
  handleToggleChange,
  setShowSharePopUp,
  isShareLoading,
  isDisabled
}) => {
  const [state, copy] = useCopyToClipboard();

  return (
    <ModalArea
      showModal={true}
      setShowModal={setShowSharePopUp}
      title={'Share'}
      size="lg"
      centered={true}
      body={
        <div className="share-section d-flex flex-column gap-3">
          <div className="d-flex gap-3 align-items-center">
            <span className="me-3">Enable Link Sharing</span>
            {isShareLoading ? (
              <div style={{ width: '10px' }} className="position-relative">
                <Loader loading={true} size={20} thickness={2} />{' '}
              </div>
            ) : (
              <Switch disabled={isDisabled} checked={publicShare} onToggle={handleToggleChange} />
            )}
          </div>
          {publicShare && (
            <div className="share-box my-3">
              <p className="mb-0">
                <b>Anyone</b> on the internet with this link can view
              </p>
              <div>
                <span
                  className="copy-link me-3"
                  onClick={() =>
                    handleCopyURL({
                      productId,
                      productUnicode: unicode,
                      isV2: true,
                      isTexture,
                      isEmbed: true,
                      copy,
                    })
                  }>
                  Copy embed link
                </span>
                <span
                  className="copy-link"
                  onClick={() =>
                    handleCopyURL({
                      productId,
                      productUnicode: unicode,
                      isV2: true,
                      isTexture,
                      copy,
                    })
                  }>
                  Copy link
                </span>
              </div>
            </div>
          )}
        </div>
      }
    />
  );
};
